// EntrarPage.js — Rota /login. Somente ENTRAR.
// O cadastro vive em /criar-conta: separar as duas ações é o padrão do mercado
// e deixa cada tela com um objetivo só.
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import useDestinoAposEntrar from "./destinoAposEntrar";
import { FormEntrar, FormCompletarTelefone } from "./AuthForms";

const main = process.env.REACT_APP_MAIN;

const EntrarPage = () => {
  const { state } = useLocation();
  const [pedirTelefone, setPedirTelefone] = useState(false);

  // Volta para onde a pessoa estava indo — rota e aba. Ver destinoAposEntrar.js.
  const concluir = useDestinoAposEntrar();

  // Quem entrou pelo Google e ainda não tem telefone ganha um passo a mais,
  // no lugar do formulário — mesma troca de tela que /criar-conta já faz com o
  // código de verificação. `concluir` é o destino nos dois caminhos porque o
  // passo é pulável: a autenticação já aconteceu, o número é o que falta.
  if (pedirTelefone) {
    return (
      <AuthLayout titulo="Quase lá!">
        <FormCompletarTelefone onConcluir={concluir} />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      titulo="Entrar na sua conta"
      subtitulo="Acesse seus e-books, pedidos e InsigneCoins."
      rodape={
        <>
          Ainda não tem conta?{" "}
          <Link to={main + "criar-conta"} state={state} className="link-sublinhado text-insigne-orange font-semibold">
            Criar conta
          </Link>
        </>
      }
    >
      <FormEntrar onSucesso={concluir} onPrecisaTelefone={() => setPedirTelefone(true)} />
    </AuthLayout>
  );
};

export default EntrarPage;
